import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Receipt from '../../../../../assets/images/module/general/ReceiptDummy.png';
import { Row, Col, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import CustomModal from '.';
import { showNotification } from '@mantine/notifications';
import ColorButton from '../Buttons/ColorButton';
import CopyIcon from '../../../SVGs/copyIcon';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import RedCross from '../../../../../assets/images/module/general/RedCross.svg';
import UpRightArrow from '../../../../../assets/images/module/general/UpRightArrow.svg';
import { Checkbox, Group, Stack, TextInput } from '@mantine/core';
import EmptyStateContainer from '../EmptyStateContainer/EmptyStateContainer';
import TenantIconBlue from '../../../../../assets/images/module/general/TenantIconBlue.svg';
import XlsxIcon from '../../../../../assets/images/module/general/XlsxIcon.svg';
import XlsxIconGrey from '../../../../../assets/images/module/general/XlsxIconGrey.svg';
import { NumericFormat } from 'react-number-format';
import DropFile from '../DropFile/DropFile';
import * as XLSX from "xlsx";
import { connect } from 'react-redux';
import Autoload from '../../../../Autoload';
import dayjs from 'dayjs';
import ErrorLogsForMultiTenantUploadModal from './ErrorLogsForMultiTenantUploadModal';
import { hasMinimumSubscriptionTier } from '../../../../../helpers/subscriptionFeatureAccess';


const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;

const {loader} =  Autoload.MainHelper

const keyMapping = {
  Einheit: "rentalUnitName",
  "Größe(m²)": "rentalUnitSpace",
  Mietertyp: "type",
  "MieterName": "name",
  "Telefonnummer(opt.)": "phone",
  "E-MailAdresse(opt.)": "email",
  "Einzugsdatum(TT.MM.JJJJ)": "in",
  "Auszugsdatum(TT.MM.JJJJ) (opt.)": "out",
  Kaltmiete: "netRent",
  Vorauszahlungen: "prePayments",
  "Notizen(opt.)": "notes"
};

export class ImportTenantsFromExcelFileModal extends Component {
  state = {
    isMobile: window.innerWidth <= MOBILE_SIZE,
    isTablet: window.innerWidth <= TABLET_SIZE,
    excelFile: null,
    hoverExcelIcon: false,
    allTenantsList: [],
    openErrorLogForTenantUploadModal: false,
    tenants: [],
    tenantsAlreadyInSystemDetected: [],
    tenantsWithDataError: [],
    errorsFound: false,
    postCallRentalUnitsCreated: [],
    validationDone: false
  };
  
  constructor(props) {
    super(props);
  }

  componentDidMount(){
    this.setDefaultTenantsData();
  }

  setDefaultTenantsData=()=>{
    const {rentalUnits} = this.props;
    let {tenants}= this.state;
    
    console.log('componentDidMount: ', rentalUnits);
    rentalUnits.map((rentalUnit)=> rentalUnit.tenantsData.map((tenant)=> tenant.vacant === false && tenants.push({...tenant, rentalUnitName: rentalUnit.name, alreadyInSystem: true})));

    this.setState({tenants});
  }

  handleExcelFileUpload = (acceptedFile, rejectedFile) => {
    const file = acceptedFile[0];
    this.setState({excelFile: [file]});
  }

  startValidation=()=>{
    const file = this.state.excelFile[0];
    if(file){
      const reader = new FileReader();
      console.log('jsonData: ', file);
      reader.onload = (e) => {
        const binaryData = e.target.result;
        const workbook = XLSX.read(binaryData, { type: "binary" });
  
        // Read the first sheet
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
  
        // Convert sheet to JSON
        let jsonData = XLSX.utils.sheet_to_json(sheet);
        //removing spaces from object key names to avoid any error
        const cleanedJsonData = jsonData.map((jsonDataObject)=> 
          Object.fromEntries(
            Object.entries(jsonDataObject).map(([key, value]) => [key.replace(/\s+/g, ''), value])
          )
        ); 
        jsonData= cleanedJsonData.map((jsDt)=> this.replaceObjectKeys(jsDt, keyMapping));
  
        console.log('jsonData: ', jsonData);
        if(jsonData.length > 0){
          let {tenants} = this.state;
          jsonData.map((tenant)=> tenants.push(tenant));
          this.setState({tenants}, this.validateTenantData(tenants));
        }else{
          showNotification({
            message: 'Es wurden keine Einträge in der Import-Datei erkannt.',
            icon: <img src={RedCross} alt={'red-cross'} />
          })
        }
      };
  
      reader.readAsBinaryString(file);
    }
  }

  checkForDatesConflict = () => {
    let { tenants } = this.state;
    let groupByRentalUnits = [];
    const rentalUnits = this.removeDuplicatesFromArray(tenants.map((tenant) => tenant.rentalUnitName));
  
    rentalUnits.forEach((rentalUnitName) => {
      let filterTenantsByRentalUnit = tenants.filter((tenant) => tenant.rentalUnitName === rentalUnitName);
  
      // Sort by move-in for this logic to work
      filterTenantsByRentalUnit.sort((a, b) => new Date(this.parseDate(a?.in)) - new Date(this.parseDate(b?.in)));
  
      // Update tenants with missing out dates
      for (let i = 0; i < filterTenantsByRentalUnit.length; i++) {
        const current = filterTenantsByRentalUnit[i];
        const next = filterTenantsByRentalUnit[i + 1];
  
        if (!current.out && next) {
          const nextInDate = new Date(this.parseDate(next?.in));
          nextInDate.setDate(nextInDate.getDate() - 1);
  
          // Format as DD.MM.YYYY
          const day = String(nextInDate.getDate()).padStart(2, '0');
          const month = String(nextInDate.getMonth() + 1).padStart(2, '0');
          const year = nextInDate.getFullYear();
          current.out = `${day}.${month}.${year}`;
        }
      }
  
      let rentalUnit = {
        name: rentalUnitName,
        tenants: filterTenantsByRentalUnit
      };
      groupByRentalUnits.push(rentalUnit);
    });
  
    let overlapsDetected = [];
  
    groupByRentalUnits.forEach((rentalUnit) => {
      let detectedOverlaps = this.detectOverlappingTenantsOptimized(rentalUnit.tenants);
  
      tenants = tenants.map((tenant) => {
        if (tenant.id === undefined) {
          if (detectedOverlaps.find((overlap) => overlap.name === tenant.name)) {
            tenant.dateOverlap = true;
          }
        }
        return tenant;
      });
  
      detectedOverlaps.forEach((overlap) => {
        overlapsDetected.push({ ...overlap, dateOverlap: true });
      });
    });
    this.setState({ tenants }, () => this.detectIfTenantAlreadyExist());
  };
  

  createNewTenants=(tenants)=>{
    console.log('createNewTenants: ', tenants);
    if(tenants.find((tenant)=> tenant.nameError || tenant.rentalUnitError || tenant.typeError || tenant.moveInDateError || tenant.alreadyInSystem || tenant.dateOverlap) !== undefined){
      // showNotification({
      //   message: 'There are errors in data provided.',
      //   icon: <img src={RedCross} alt='red-cross'/>
      // });

      this.setState({errorsFound: true});
    }
    this.setState({openErrorLogForTenantUploadModal: true, validationDone: true});
    // else{
    //   this.postTenant(tenants[0], 0, tenants.length);
    // }
  }

  postCall=(tenant, currentIndex, eol)=>{
    const {rentalUnits} = this.props;
    const {postCallRentalUnitsCreated} = this.state;
    const rentalUnitAlreadyExist = postCallRentalUnitsCreated.find((rentalUnit)=> rentalUnit?.name === tenant?.rentalUnitName);
    loader(true);
    if(rentalUnits.find((rentalUnit)=> rentalUnit.name === tenant.rentalUnitName) === undefined && rentalUnitAlreadyExist === undefined){
      this.postRentalUnit(tenant, currentIndex, eol);
    }else if(tenant?.rentalUnitId === undefined && rentalUnitAlreadyExist !== undefined){
      this.postTenant({...tenant, rentalUnitId: rentalUnitAlreadyExist?.id}, currentIndex, eol);
    }else{
      this.postTenant(tenant, currentIndex, eol);
    }
  }

  postRentalUnit=(tenant, currentIndex, eol)=>{
    const {propertySelected} = this.props;
    var data = JSON.stringify({
      rentalUnitId: null,
      propertyId: propertySelected?.id,
      name: tenant.rentalUnitName,
      space: tenant.rentalUnitSpace ? tenant.rentalUnitSpace : 0,
      rentalUnitType: 'REGULAR',
      isUtilityBillingEnabled: true,
    });
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'RentalUnits',
      'POST',
      data,
      null,
      false,
      true,
      false,
      this,
      'handlePostRentalUnit',
      {tenant, currentIndex, eol},
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handlePostRentalUnit(response){
    let {postCallRentalUnitsCreated} = this.state;
    postCallRentalUnitsCreated.push({name: response?.other?.tenant?.rentalUnitName, id: response?.result?.id});
    this.setState({postCallRentalUnitsCreated}, ()=> this.postTenant({...response.other.tenant, rentalUnitId: response?.result?.id}, response.other.currentIndex, response.other.eol));
  }

  postTenant=(tenant, currentIndex, eol)=>{
    const { rentalUnits } = this.props;
    // // ;
    console.log('postTenant: ', tenant);
    let data = JSON.stringify({
      tenantId: null,
      rentalUnitId: tenant?.rentalUnitId ? tenant?.rentalUnitId : rentalUnits.find((rentalUnit)=> rentalUnit.name === tenant.rentalUnitName)?.id,
      fullName: tenant?.name,
      contractType: this.convertTenantType(tenant?.type),
      vacant: false,
      phone: tenant?.phone,
      email: tenant?.email,
      moveInDate: dayjs(tenant?.in, 'DD.MM.YYYY').format('YYYY-MM-DDTHH:mm:ss'),
      moveOutDate: tenant?.out ? dayjs(tenant?.out, 'DD.MM.YYYY').format('YYYY-MM-DDTHH:mm:ss') : null,
      notes: tenant?.notes,
    });
    console.log('data api add tenant', data);

    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'tenants',
      'POST',
      data,
      null,
      false,
      true,
      false,
      this,
      'handlePostTenant',
      {tenant, currentIndex, eol},
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handlePostTenant(response){
    const {tenants} = this.state;
    if(response.status && response.statuscode === 200){
        this.postRent({...response.other.tenant, id: response.result.id}, response.other.currentIndex, response.other.eol);
    }else{
      if((response.other.currentIndex+1) < response.other.eol){
        this.postCall(tenants.filter((tenant)=> tenant.alreadyInSystem === false)[response.other.currentIndex+1], (response.other.currentIndex+1), tenants.filter((tenant)=> tenant.alreadyInSystem === false).length);
      }else if(response.other.eol === (response.other.currentIndex+1)){
        showNotification({
          message: 'Der Datenimport wurde erfolgreich durchgeführt.',
          icon: <img src={GreenTick} alt='green-tick'/>
        });
        loader(false);
        this.props.toggle(true);
      }
    }
  }

  postRent=(tenant, currentIndex, eol)=>{
    let data = JSON.stringify({
      rentId: null,
      tenantId: tenant.id,
      startDate: dayjs(tenant.in, 'DD.MM.YYYY').format('YYYY-MM-DDTHH:mm:ss'),
      endDate: tenant?.out ? dayjs(tenant?.out, 'DD.MM.YYYY').format('YYYY-MM-DDTHH:mm:ss') : null,
      netRent: tenant?.netRent ? tenant?.netRent : 0,
      prePayments: tenant?.prePayments ? tenant?.prePayments : 0,
    });

    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'rents',
      'POST',
      data,
      null,
      false,
      true,
      false,
      this,
      'handlePostRent',
      {tenant, currentIndex, eol},
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handlePostRent(response){
    const {tenants} = this.state;
    // if(response.status && response.statuscode === 200){
      console.log('handlePostRent: ', response.other.eol, (response.other.currentIndex+1));
      if((response.other.currentIndex+1) < response.other.eol){
        this.postCall(tenants.filter((tenant)=> tenant.alreadyInSystem === false)[response.other.currentIndex+1], (response.other.currentIndex+1), tenants.filter((tenant)=> tenant.alreadyInSystem === false).length);
      }else if(response.other.eol === (response.other.currentIndex+1)){
        showNotification({
          message: 'Der Datenimport wurde erfolgreich durchgeführt.',
          icon: <img src={GreenTick} alt='green-tick'/>
        });
        loader(false);
        this.props.toggle(true);
      }
    // }
  }

  convertTenantType=(type)=>{
    switch (type) {
      case "Privater Mieter":
        return "private";
      case "Gewerbe":
        return hasMinimumSubscriptionTier(this.props.currentSubscription, 'PREMIUM') ? "commercial" : "private";
      case "Selbstnutzer":
        return "self";
      default:
        return "private";
    }
  }

  validateTenantData=(tenants)=>{
    const {rentalUnits} = this.props;
    let tenantsCopy = tenants;
    
    tenantsCopy = tenantsCopy.map((tenant)=> {
      if(tenant.id === undefined){
        if(this.isValueEmpty(tenant.name)){
          tenant.nameError= true;
        } 
        if(this.isValueEmpty(tenant.rentalUnitName)){
          tenant.rentalUnitError= true;
        } 
        if(this.isValueEmpty(tenant.type)){
          tenant.typeError= true;
        } 
        if(this.isValueEmpty(tenant.in)){
          tenant.moveInDateError= true;
        }
      }
      return tenant;
    });

    this.setState({tenants: tenantsCopy}, ()=> this.checkForDatesConflict());
  }

  isValueEmpty=(value)=>{
    return (value === null || value === undefined || value === '');
  }

  detectIfTenantAlreadyExist=()=>{
    let {tenants, tenantsAlreadyInSystemDetected} = this.state;
    console.log('detectIfTenantAlreadyExist: ', tenants);
    const tenantsAlreadyInSystem = tenants.filter((tenant)=> tenant.alreadyInSystem);
    const tenantsAlreadyNotInSystem = tenants.filter((tenant)=> tenant.alreadyInSystem === false);
    if(tenantsAlreadyInSystem.length > 0){
      tenantsAlreadyInSystemDetected = tenantsAlreadyNotInSystem.filter((tenantNotExist)=> tenantsAlreadyInSystem.find((tenantExist)=> tenantExist.name === tenantNotExist.name && tenantExist.rentalUnitName === tenantNotExist.rentalUnitName && tenantExist.in === tenantNotExist.in) !== undefined);
      console.log('tenantsAlreadyInSystemDetected: ', tenantsAlreadyInSystemDetected, tenants);
      if(tenantsAlreadyInSystemDetected.length > 0){
        tenants = tenants.map((tenant)=> {
          if(tenantsAlreadyInSystemDetected.find((tenantDetected)=> tenant.name === tenantDetected.name && tenant.rentalUnitName === tenantDetected.rentalUnitName && tenant.in === tenantDetected.in) !== undefined){
            tenant.alreadyInSystem = true;
          }
          return tenant;
        });
        //this.setState({openErrorLogForTenantUploadModal: true, tenants});
        this.setState({tenants}, ()=> 
          this.createNewTenants(tenants)//this.validateTenantData(tenants.filter((tenant)=> tenant.id === undefined))
        );
      }else{
        this.createNewTenants(tenants)//this.validateTenantData(tenants.filter((tenant)=> tenant.alreadyInSystem === false));
      }
    }else{
      this.createNewTenants(tenants)//this.validateTenantData(tenants.filter((tenant)=> tenant.alreadyInSystem === false));
    }
  }
  
  parseDate=(dateStr)=> {
    if(dateStr && typeof dateStr === 'string' && dateStr.split(".").length === 3){
      console.log('dateStr: ', dateStr);
      
      const [day, month, year] = dateStr.split(".");
      return new Date(`${year}-${month}-${day}T00:00:00`); // ISO format
    }else{
      return new Date('not-a-date');
    }
  }

  detectOverlappingTenantsOptimized = (tenants) => { //1st
    // Sort tenants by in
    tenants.sort((a, b) => new Date(a.in) - new Date(b.in));
    let moveInDateOverlapsDetected= [];
    const overlaps = [];

    moveInDateOverlapsDetected = tenants.filter((tenantA)=> tenants.find((tenantB)=> tenantA.name !== tenantB.name && tenantA.in === tenantB.in) !== undefined);
  
    for (let i = 0; i < tenants.length; i++) {
      const tenantA = tenants[i];
      const moveInA = new Date(this.parseDate(tenantA?.in));
      const moveOutA = tenantA.out ? new Date(this.parseDate(tenantA.out)) : Infinity;
  
      for (let j = i + 1; j < tenants.length; j++) {
        const tenantB = tenants[j];
        const moveInB = new Date(this.parseDate(tenantB?.in));
  
        console.log('moveInB > moveOutA: ', moveInB > moveOutA, moveInB, tenantB.in, moveOutA);
        if (moveInB > moveOutA) break; // No overlap possible since list is sorted
  
        const moveOutB = tenantB.out ? new Date(this.parseDate(tenantB.out)) : Infinity;
  
        if (moveInA <= moveOutB && moveInB <= moveOutA) {
          if(moveInDateOverlapsDetected.find((tenant)=> tenant.name === tenantA.name) === undefined){
            overlaps.push(tenantA);
          }
          if(moveInDateOverlapsDetected.find((tenant)=> tenant.name === tenantB.name) === undefined){
            overlaps.push(tenantB);
          }
        }
      }
    }
    moveInDateOverlapsDetected.forEach((tenant)=> overlaps.push(tenant));
    return overlaps;
  };

  removeDuplicatesFromArray = (array) => [...new Set(array)];

  removeDuplicatesFromArrayOfObjects = (array, key) => {
    const seen = new Set();
    return array.filter((item) => {
      const keyValue = item[key];
      if (seen.has(keyValue)) {
        return false;
      }
      seen.add(keyValue);
      return true;
    });
  };

  removeFile=()=>{
    this.setState({excelFile: null, errorsFound: false, tenants: [], validationDone: false}, ()=> this.setDefaultTenantsData());
  }

  replaceObjectKeys = (obj, keyMapping) => {
  return Object.keys(obj).reduce((newObj, key) => {
    // Map to the new key if present
    const newKey = keyMapping[key] || key;
    let value = obj[key];

    console.log('newKey: ', newKey, 'value: ', value);
    

    // If the key looks like a date field, normalize it
    if (
      /in/i.test(newKey) || 
      /out/i.test(newKey) || 
      newKey.toLowerCase().includes('date')
    ) {
      console.log('Normalizing date for key:', newKey, 'with value:', value);
      
      value = this.normalizeDate(value);
    }

    // Add the property to newObj
    newObj[newKey] = value;

    // Return the extended object with defaults
    return {
      ...newObj,
      alreadyInSystem: false,
      nameError: false,
      rentalUnitError: false,
      typeError: false,
      moveInDateError: false,
      dateOverlap: false,
      netRent: newObj.netRent === undefined ? 0 : newObj.netRent,
      prePayments: newObj.prePayments === undefined ? 0 : newObj.prePayments,
    };
  }, {});
};


  // replaceObjectKeys = (obj, keyMapping) => {
  //   return Object.keys(obj).reduce((newObj, key) => {
  //     // Use the mapped key if it exists, otherwise use the original key
  //     const newKey = keyMapping[key] || key;
  //     newObj[newKey] = obj[key];
  //     return {...newObj, alreadyInSystem: false, nameError: false, rentalUnitError: false, typeError: false, moveInDateError: false, dateOverlap: false, netRent: newObj.netRent === undefined ? 0 : newObj.netRent, prePayments: newObj.prePayments === undefined ? 0 : newObj.prePayments};
  //   }, {});
  // };

  handleDownload = () => {
    // Create a link element
    const link = document.createElement("a");
    // Set the href to the file path
    link.href = '/Mieter hinzufügen.xlsx';
    // Set the download attribute
    link.download = 'Import Mieterdaten.xlsx';
    // Append the link to the body
    document.body.appendChild(link);
    // Programmatically click the link
    link.click();
    // Remove the link from the document
    document.body.removeChild(link);
  };

  normalizeDate = (value) => {
  if (!value) return '';

  // If already a JS Date object
  if (value instanceof Date) {
    return value.toLocaleDateString('de-DE'); // e.g., 15.09.2022
  }

  // If it's a number (Excel serial)
  if (typeof value === 'number') {
    const excelDate = XLSX.SSF.parse_date_code(value);
    const day = String(excelDate.d).padStart(2, '0');
    const month = String(excelDate.m).padStart(2, '0');
    const year = excelDate.y;
    return `${day}.${month}.${year}`;
  }

  // Otherwise assume string
  return value;
};

  
  render() {
    const { open, toggle, className, update, rentalUnits } = this.props;
    const {excelFile, hoverExcelIcon, tenants, openErrorLogForTenantUploadModal, tenantsAlreadyInSystemDetected, tenantsWithDataError, errorsFound, validationDone} = this.state;

    console.log('tenants: ', tenants);
    console.log('openErrorLogForTenantUploadModal: ', openErrorLogForTenantUploadModal, tenantsAlreadyInSystemDetected, tenantsWithDataError);
    console.log('rentalUnits: ', rentalUnits);
    
    return (
      <CustomModal
        heading={'Sammel-Import für Mieterdaten'}
        headingClassName={'update-received-rent-modal-heading'}
        open={open}
        toggle={() => {
          toggle();
        }}
        className={`${className}`}
      >
        <Stack>
            <Group gap={0}>
              <p style={{fontFamily: 'Inter, sans-serif', fontWeight: '400', marginBottom: 0, color: '#13135c'}}>Nutzen Sie den Sammel-Import für Mieterdaten, um Informationen zu Mietern und Mieteinheiten, die Sie aus Drittsystemen importieren, in hellohousing schnell anzulegen.</p>
            </Group>
            <Group>
              <p style={{fontFamily: 'Inter, sans-serif', fontWeight: '400', marginBottom: 0, color: '#13135c'}}>Nutzen Sie diese Excel-Vorlage, um die Daten bereitzustellen:</p>
            </Group>
            <Group justify='center' wrap="nowrap">
              {/* <Group className='excel-tenants-file-container' onClick={()=> this.handleDownload()} gap={10} wrap="nowrap" onMouseEnter={()=> this.setState({hoverExcelIcon: true})} onMouseLeave={()=> this.setState({hoverExcelIcon: false})}> */}
                {/* <a className='excel-tenants-file-link' onClick={()=> this.handleDownload()}>Vorlage herunterladen</a> */}
                <span className="navigate-button" style={{fontSize: '14px'}} onClick={()=> this.handleDownload()}>
                  <img src={UpRightArrow} style={{width: '10px', height: '10px', marginRight: '5px', marginTop: '-2px'}}/>{'Vorlage herunterladen'}
                </span>
              {/* </Group> */}
            </Group>
            <Group gap={0}>
              <p style={{fontFamily: 'Inter, sans-serif', fontWeight: '400', marginBottom: 0, color: '#13135c'}}>Die Daten können Sie im Anschluss hier hochladen:</p>
            </Group>
            <Group style={{width: '100%'}} grow>
              <div>
                <DropFile
                downloadable
                accept={'.xlsx'}
                fileType={'xlsx'}
                customProps={{ multiple: false }}
                handleDrop={this.handleExcelFileUpload}
                file={excelFile}
                removeFile={this.removeFile}
                multiSelect={false}
                maxSize={100000000}
                hideSecondText={true}
                innerWrapperStyle={{marginBottom: excelFile === null && 0}}
                //selectedFileStyle={{color: errorsFound && 'red'}}
                onClick={()=> errorsFound && this.setState({openErrorLogForTenantUploadModal: true})}
                />
              </div>
            </Group>
            {/* <Group>
              <p style={{fontFamily: 'Inter, sans-serif', fontWeight: '400', marginBottom: 0, color: '#13135c'}}>Klicken Sie auf <span style={{fontWeight: 'bold'}}>Überprüfen</span>, um den Import zu überprüfen.</p>
            </Group> */}
            <Group justify="space-between">
                <div>
                    <ColorButton
                    text={'Abbrechen'}
                    className='gray-btn'
                    onClick={()=> toggle()}
                    />
                </div>
                <div>
                    <ColorButton
                    text={'Überprüfen'}
                    className='purple-btn'
                    onClick={()=> validationDone ? this.setState({openErrorLogForTenantUploadModal: true}) : this.startValidation()}
                    disabled={!excelFile}
                    />
                </div>
            </Group>
            {openErrorLogForTenantUploadModal &&
            <ErrorLogsForMultiTenantUploadModal
            open={openErrorLogForTenantUploadModal}
            toggle={()=> this.setState({openErrorLogForTenantUploadModal: false})}
            tenants={tenants.filter((tenant)=> tenant.id === undefined)}
            next={()=> this.postCall(tenants.filter((tenant)=> tenant.alreadyInSystem === false)[0], 0, tenants.filter((tenant)=> tenant.alreadyInSystem === false).length)}
            />}
        </Stack>
      </CustomModal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    propertySelected: state.generalReducer.property,
    rentalUnits: state.tenantDataReducer.rentalUnits,
    currentSubscription: state.generalReducer.currentSubscription,
  };
};

export default connect(mapStateToProps)(ImportTenantsFromExcelFileModal);
